










































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Borough } from "../model/Boroughs";
import { Gender } from "../model/Model";
import DownloadBanner from "./DownloadBanner.vue";

@Component({
  components: {
    DownloadBanner
  }
})
export default class DownloadDrinkCoachApp extends Vue {
  public static navButtonClasses: string[] = ["download-drinkcoach"];
  public static navButtonLabel: () => string = () =>
    "Download our FREE DrinkCoach app";

  @Prop() public score!: number;
  @Prop() public units!: number;
  @Prop() public calories!: number;
  @Prop() public gender!: Gender;
  @Prop() public region!: Borough;
  @Prop() public commissioned!: boolean;
  @Prop() public isMobile!: boolean;
}
